module.exports = __webpack_public_path__ + "static/media/27OCHA20.e030e4cd.jpg";